import { PropsWithChildren, createContext, useContext } from "react";

type SSRLoginStateContextType = {
    hasCloudSessionTokenCookie: boolean;
};

const SSRLoginStateContext = createContext<SSRLoginStateContextType>({
    hasCloudSessionTokenCookie: false
});

export const useSSRLoginState = () => {
    const context = useContext(SSRLoginStateContext);
    if (!context) {
        throw new Error(
            "useSSRLoginState must be used within SSRLoginStateProvider"
        );
    }
    return context;
};

type SSRLoginStateProviderProps = PropsWithChildren & {
    hasCloudSessionTokenCookie?: boolean;
};

export const SSRLoginStateProvider = ({
    children,
    hasCloudSessionTokenCookie = false
}: SSRLoginStateProviderProps) => {
    return (
        <SSRLoginStateContext.Provider value={{ hasCloudSessionTokenCookie }}>
            {children}
        </SSRLoginStateContext.Provider>
    );
};
